import { IonIcon } from "@ionic/react";
import { cartOutline } from "ionicons/icons";

export default function EmptyShopList() {
  return (
    <div className="h-full w-full flex flex-col items-center justify-center text-center gap-2">
      <IonIcon icon={cartOutline} className="w-24 h-24" />

      <h3 className="text-xl font-semibold text-gray-900">No items found</h3>

      <p className="text-gray-500 text-sm">
        Looks like you've already got everything!
      </p>
    </div>
  );
}
